import axios from 'axios';
import store from '../redux/store/store';
import { CC_API_BASE_URL, getCcRequestConfig } from '../config/ccApiConfig';

// API URL'yi çekiyoruz
const API_URL = import.meta.env.VITE_API_URL;

const userApplicationService = {
  // Kullanıcının aboneliklerini getiren method
  fetchUserApplications: async () => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      
      if (!userToken) {
        throw new Error('Kullanıcı oturumu bulunamadı');
      }
      
      const response = await axios.get(`${API_URL}/UserApplication`, {
        headers: {
          Authorization: `Bearer ${userToken}`,
          'Content-Type': 'application/json',
        }
      });
      
      return response.data;
    } catch (error) {
      console.error('Kullanıcı abonelikleri alınırken hata oluştu:', error);
      throw error;
    }
  },
  
  // Kullanıcı aboneliği oluşturma
  createApplication: async (applicationData) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      
      if (!userToken) {
        throw new Error('Kullanıcı oturumu bulunamadı');
      }
      
      const response = await axios.post(`${API_URL}/UserApplication`, applicationData, {
        headers: {
          Authorization: `Bearer ${userToken}`,
          'Content-Type': 'application/json',
        }
      });
      
      return response.data;
    } catch (error) {
      console.error('Abonelik oluşturulurken hata oluştu:', error);
      throw error;
    }
  },
  
  // 14 günlük deneme sürümü oluşturma
  createTrialApplication: async (applicationData) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const userId = store.getState()?.auth?.user?.id;
      
      if (!userToken) {
        throw new Error('Kullanıcı oturumu bulunamadı');
      }
      
      // Abonelik tipine göre data oluşturma
      const postData = {
        userId: userId,
        ...applicationData,
        ia: true // Active durumda
      };
      
      const response = await axios.post(`${API_URL}/UserApplication`, postData, {
        headers: {
          Authorization: `Bearer ${userToken}`,
          'Content-Type': 'application/json',
        }
      });
      
      return response.data;
    } catch (error) {
      console.error('Deneme sürümü oluşturulurken hata oluştu:', error);
      throw error;
    }
  },
  
  // CC API ile kontrol (eğer varsa)
  checkCCApplicationStatus: async (applicationId) => {
    try {
      const response = await axios.get(
        `${CC_API_BASE_URL}/ApplicationStatus?applicationId=${applicationId}`,
        getCcRequestConfig()
      );

      return response.data;
    } catch (error) {
      console.error('CC API ile kontrol edilirken hata oluştu:', error);
      throw error;
    }
  },
  
  // Kullanıcı satın alma işlemi için yönlendirme
  redirectToPurchase: (applicationType, applicationId) => {
    // Burada satın alma sayfasına yönlendirme işlemi yapılabilir
    // Örnek: window.location.href = `/payment?type=${applicationType}&id=${applicationId}`;
    return `/payment?type=${applicationType}&id=${applicationId}`;
  }
};

export default userApplicationService; 